<nz-layout id="purchase-invoice-today">
    <div class="purchase-invoice-today-header" nz-row>
        <div nz-col nzSpan="5" class="title left-all-content">
          <b>{{data.name}}</b>
        </div>
        <div nz-col nzSpan="13" class="left-all-content">
          <div class="search">
            <nz-input-group [nzSuffix]="suffixIconSearch">
              <input type="text" nz-input placeholder="Tìm kiếm tên sản phẩm" [(ngModel)]="searchNameProduct"
                (keyup.enter)="onSearchProduct(1)" />
            </nz-input-group>
            <ng-template #suffixIconSearch>
              <span (click)="onSearchProduct(1)" nz-icon nzType="search"></span>
            </ng-template>
          </div>
        </div>
      </div>
    <div style="margin-top:16px">
        <nz-table [nzScroll]="{ y: tableHeight }" [nzData]="showProduct" #tableSales [nzShowPagination]="false" [nzFrontPagination]="false"
      nzShowSizeChanger>
      <thead>
        <tr>
          <th nzWidth="2%"><span></span></th>
          <th nzWidth="8%"><b>Ảnh</b></th>
          <th nzWidth="40%" nzAlign="left"><b>Tên sản phẩm</b></th>
          <th nzWidth="10%" nzAlign="center"><b>Ẩn/ Hiện</b></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of showProduct; trackBy: trackByFn">
          <tr>
            <td style="cursor: pointer;" (click)="$event.stopPropagation(); item.show_expand = !item.show_expand ">
              <i class="icon-expand" *ngIf="item.manysize" nz-icon [nzType]="item.show_expand ? 'up' : 'down'"
                nzTheme="outline"></i>
            </td>
            <td>
              <div class="image d-flex align-items-center">
                <img onerror="this.src='./assets/root/icon/management/image_default.svg'" [src]="item.imgs[0]"
                  [alt]="item.name" width="%" style="width: 70px">
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-start text-start" style="font-weight: 600;">
                <span>{{ item.name }}</span>
              </div>
            </td>
            <td nzAlign="center">
              <div class="status" *ngIf="!item.manysize">
                <label class="switch">
                  <nz-switch [(ngModel)]="item[this.data._id+'_hidden']"
                    (ngModelChange)="updateShowWeb(item._id,$event)"></nz-switch>
                    <!-- <input type="checkbox" [checked]="item[this.data._id+'_hidden']"
                    (change)="updateShowWeb(item._id,$event)"> -->
                </label>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
        </nz-table>
        <div class="pagination mt-3">
        <div class="pagination-list-button">
          <div class="page-start pagiItem" (click)="gotoPreviousPage()">Trước</div>
          <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent > 3" (click)="transferFn(1)">
            1
          </div>
          <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent > 3">
            ...
          </div>
          <div *ngFor='let page of pageShowChoose ;let i = index'>
            <div class="page-number pagiItem" *ngIf="page <= totalPages && page > 0"
              [ngClass]="{'active': page == pageCurrent}" (click)="transferFn(page)">
              {{page}}
            </div>
          </div>
          <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent < totalPages-1">
            ...
          </div>
          <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent < totalPages-1"
            (click)="transferFn(totalPages)">
            {{totalPages}}
          </div>
          <div class="page-end pagiItem" (click)="gotoNextPage()">Sau</div>
          <button nz-popover [nzPopoverTitle]="'Tối đa ' +  totalPages" [nzPopoverContent]="contentTemplate"
            class="page-go pagiItem" nzPopoverPlacement="top">
            Tới trang
          </button>
        </div>
        <ng-template #contentTemplate>
          <div class="input-container">
            <input placeholder="Nhập trang cần tới" type="number" [(ngModel)]="pageGoto" />
            <div class="goto-page" (click)="transferFn((pageGoto <= totalPages && pageGoto > 0)  ? pageGoto : 1)">Tới
            </div>
          </div>
        </ng-template>
        </div>
    </div>
</nz-layout>